module.exports = __webpack_public_path__ + "static/img/40013 (4).1af1593.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40013 (4).webp
// module id = 81uK
// module chunks = 14